import type { Tenant } from '#/graphql/types';
import type { ObjectImportConfig } from '../asset/SubmitModal';

/**
 * Shared "resolve TenantModel by dataSourceId" lookup config, reused by every entity's CSV
 * import wizard (Asset, Work Order, Finding, ...).
 */
export function buildTenantImportConfig(selectedTenant: Tenant): ObjectImportConfig {
  return {
    model: 'TenantModel',
    fixedId: selectedTenant.id,
    thirdPartyId: 'dataSourceId',
    columnMap: {
      dataSourceId: { defaultValue: selectedTenant.dataSourceId ?? '' },
    },
    onlyForMapping: true,
  };
}

/**
 * Shared "resolve AssetModel by Serial Number or Asset Tag" lookup config, reused by the
 * Work Order and Finding CSV import wizards (both attach their records to an existing Asset).
 */
export function buildAssetLookupImportConfig(
  uniqueField: string,
  mapping: Record<string, string>,
): ObjectImportConfig {
  const assetLookupField = uniqueField === 'serial_number' ? 'serialNumber' : 'assetTag';

  return {
    model: 'AssetModel',
    thirdPartyId: assetLookupField,
    columnMap: {
      [assetLookupField]: mapping[uniqueField],
      tenantId: {
        relatedTo: 'TenantModel',
      },
    },
    onlyForMapping: true,
    uniqueForTenant: true,
  };
}
